<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  components: {
  },
  setup() {

    return {  };
  },
});
</script>

<template>
  <v-card>
    <v-card-title>
      BatAI Help
    </v-card-title>
    <v-card-text class="ma-5">
      <p>
        Please utilize the Help Icon <v-icon>mdi-help</v-icon> to get information about Shortcuts, Uploading, and creating Annotations.
      </p>
    </v-card-text>
  </v-card>
</template>
